var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.value),function(tag){return _c('v-chip',{key:tag,attrs:{"x-small":""},on:{"click":function($event){$event.stopPropagation();return _vm.tagClicked(tag)}}},[_vm._v(_vm._s(tag))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }